var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2947_4476)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0013 18.3333C14.6037 18.3333 18.3346 14.6024 18.3346 10C18.3346 5.39763 14.6037 1.66667 10.0013 1.66667C5.39893 1.66667 1.66797 5.39763 1.66797 10C1.66797 14.6024 5.39893 18.3333 10.0013 18.3333Z",
    fill: "#7C7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.3333C14.6037 18.3333 18.3346 14.6024 18.3346 10C18.3346 5.39763 14.6037 1.66667 10.0013 1.66667C5.39893 1.66667 1.66797 5.39763 1.66797 10C1.66797 14.6024 5.39893 18.3333 10.0013 18.3333Z",
    stroke: "#7C7F7E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 7.49999C8.33203 6.57952 9.0782 5.83333 9.9987 5.83333C10.9192 5.83333 11.6654 6.57952 11.6654 7.49999C11.6654 7.83179 11.5684 8.14094 11.4013 8.40066C10.9032 9.17474 9.9987 9.91283 9.9987 10.8333V11.25",
    stroke: "#7C7F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 14.1667H9.99969",
    stroke: "#7C7F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2947_4476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4b74e6950de2e90b26a1ca4da67636a6.svg";
export { ForwardRef as ReactComponent };